module.exports = __webpack_public_path__ + "static/media/14.87c9a02e.jpg";